// extracted by mini-css-extract-plugin
export var numpadContainer = "_qn-1";
export var phoneButton = "_qn-0";